import { PageBreadcrumb } from "./Breadcrumb";
import { PageCard } from "./Card";
import type { ReactNode } from "react";

// The frame every org-level page shares. Children sit directly in the card:
// these pages bring their own content wrappers rather than one shared body.
export function DefaultPageCard({
  currentPage,
  isOrgScoped: isWorkspaceScoped = true,
  className,
  children,
}: {
  currentPage: string;
  isOrgScoped?: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <PageCard surface="primary" scrollable={false} className={className}>
      <PageCard.Header>
        <PageBreadcrumb current={currentPage} isOrgScoped={isWorkspaceScoped} />
      </PageCard.Header>
      {children}
    </PageCard>
  );
}
